import axios from "axios";

export default {
    methods: {
        pushDataSingle(product) {
            dataLayer.push({
                'event': 'add_tocart_button_product_page',
                'value': product.price, // цена товара
                'items': [{
                    'id': product.code, // код товара (именно код, а не ID)
                    'google_business_vertical': 'retail'
                }]
            });

            fbq('track', 'AddToCart', {
                content_ids: product.code,  // код товара (именно код, а не ID)
                content_type: 'product',
                currency: 'UAH',
                value: product.price  // цена товара
            });
        },
        pushDataListing(product) {
            dataLayer.push({
                'event': 'add_tocart_button_product_сat',
                'value': product.price, // цена товара
                'items': [{
                    'id': product.code, // код товара (именно код, а не ID)
                    'google_business_vertical': 'retail'
                }]
            });

            fbq('track', 'AddToCart', {
                content_ids: product.code,  // код товара (именно код, а не ID)
                content_type: 'product',
                currency: 'UAH',
                value: product.price  // цена товара
            });
        },

        async pushDataAddToCart(product) {
            let productDefaultLanguageMeta = await this.getProductDefaultLanguageMeta(product.id);
            if (productDefaultLanguageMeta) {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: "add_to_cart",
                    ecommerce: {
                        items: [
                            {
                                item_name: productDefaultLanguageMeta.title,  //название товара    
                                item_id: product.code,  //идентификатор товара
                                price: product.price,  // цена
                                quantity: 1, // количество товара
                                currency: "UAH",  //валюта
                            }]
                    }
                });
            }
        },
        async getProductDefaultLanguageMeta(id) {
            return axios({
                method: "get",
                url: "/system-open-requests/get-product-default-language-meta/" + id
            })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        }
    }
}
